export const WIDGET_POSITIONS = {
    Small: {
        first: {
            // The minimum number of products required to display the first widget on mobile or desktop.
            minProducts: [4, 7],
            position: {
                colSpan: [2, 1, 1],
                rowStart: [3, 2, 2, 2],
                fontSize: ["mobileH1", "tabletH3", "desktopH3"],
            },
        },
        second: {
            minProducts: [8, 14],
            position: {
                colSpan: [2, 1, 1],
                colStart: [1, 3, 3, 4],
                rowStart: [6, 4, 4],
                fontSize: ["mobileH1", "tabletH3", "desktopH3"],
            },
        },
    },
    Tall: {
        first: {
            minProducts: [4, 10],
            position: {
                colSpan: [2, 1, 1],
                rowSpan: 2,
                rowStart: [3, 2, 2, 2],
                fontSize: ["mobileH1", "desktopH2", "desktopH2"],
            },
        },
        second: {
            minProducts: [8, 20],
            position: {
                colSpan: [2, 1, 1],
                rowSpan: 2,
                colStart: [1, 3, 3, 4],
                rowStart: [7, 5, 5],
                fontSize: ["mobileH1", "desktopH2", "desktopH2"],
            },
        },
    },
    Big: {
        first: {
            minProducts: [4, 8],
            position: {
                colSpan: 2,
                rowSpan: 2,
                rowStart: [3, 2, 2, 2],
                fontSize: ["mobileH1", "desktopH1", "desktopH1"],
            },
        },
        second: {
            minProducts: [8, 16],
            position: {
                colSpan: 2,
                rowSpan: 2,
                colStart: [1, 1, 2, 3, 3],
                rowStart: [7, 5, 5],
                fontSize: ["mobileH1", "desktopH1", "desktopH1"],
            },
        },
    },
} as const;
